export default "__VITE_ASSET__CMCfHAsR__"